import React, { useMemo, useState, useEffect, useCallback } from "react";
import MaterialReactTable from "material-react-table";
import { ExportToCsv } from "export-to-csv";
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import axios from "axios";
import Cookies from "universal-cookie";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { Delete, Edit, Info } from "@mui/icons-material";
import EditarPerfil from "./EditarPerfil";
import DescripcionPerfil from "./DescripcionPerfil";
import Swal from "sweetalert2";

const cookie = new Cookies();

const InfoPerfilInstitucion2 = (props) => {
  const csvOptions = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalSeparator: ".",
    showLabels: true,
    useBom: true,
    useKeysAsHeaders: false,
  };
  const csvExporter = new ExportToCsv(csvOptions);

  const columns = useMemo(
    () => [
      {
        accessorKey: "idregistro",
        header: "Id",
        enableEditing: false,
      },
      {
        accessorKey: "secciones",
        header: "Seccion",
        enableEditing: false,
      },
      {
        accessorKey: "titulo",
        header: "Titulo",
        enableEditing: false,
      },
      {
        accessorKey: "subtitulos",
        header: "Subtitulo",
        enableEditing: false,
      },
      {
        accessorKey: "descripcion",
        header: "Descripción",
      },
      {
        accessorKey: "subtitulosId",
        header: "subtitulosId",
      },
    ],
    [],
  );

  const [list1, setList1] = useState([]);

  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url:
        "https://suadesarrollo.azurewebsites.net/api/ObtenerPerfilAutoevaluacion/" +
        props.idInstitucion,
    })
      .then((Response) => {
        setList1(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [props.idInstitucion]);

  const handleDeleteRow = (id) => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "Esta acción eliminará el registro de forma permanente.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        axios({
          method: "delete",
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
          url:
            "https://suadesarrollo.azurewebsites.net/api/EliminaPerfilAutoevaluacion/" +
            id,
          data: {
            TipoAccion: "Eliminación de registro en equipo autoevaluacion",
            IdUsuario: cookie.get("id"), // o 1262 si es fijo
          },
        })
          .then((response) => {
            Swal.fire(
              "¡Eliminado!",
              "El registro ha sido eliminado.",
              "success",
            );
            setList1((prev) => prev.filter((item) => item.idregistro !== id));
          })
          .catch((error) => {
            console.error(error);
            Swal.fire("Error", "No se pudo eliminar el registro.", "error");
          });
      }
    });
  };

  return (
    <div>
      <MaterialReactTable
        columns={columns}
        data={list1}
        enableMultiRowSelection={false}
        enableRowActions
        editingMode="row"
        enableEditing
        localization={MRT_Localization_ES}
        initialState={{
          showColumnFilters: true,
          columnVisibility: { subtitulosId: true },
        }}
        renderRowActions={({ row }) => (
          <Box sx={{ display: "flex", gap: "0.5rem" }}>
            <EditarPerfil
              Id={row.getValue("idregistro")}
              descripcion={row.getValue("descripcion")}
              subtitulosId={row.getValue("subtitulosId")}
            />
            <DescripcionPerfil
              idRegistro={row.getValue("idregistro")}
              subtitulosId={row.getValue("subtitulosId")}
              descripcion={row.getValue("descripcion")}
              InstitucionID={props.idInstitucion}
            />
            <Tooltip title="Eliminar">
              <IconButton
                color="error"
                onClick={() => handleDeleteRow(row.getValue("idregistro"))}
              >
                <Delete />
              </IconButton>
            </Tooltip>
          </Box>
        )}
      />
    </div>
  );
};

export default InfoPerfilInstitucion2;
